// No preloaded slices needed any more — appData starts fresh on every load
// (the only stateful UI bit is the contact form, which is local component
// state, not Redux).
export const preloadedState = {};
